
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as indexq5N0n8sE2wGW_45kyMG4AX7tGXJIlw_45dPY8Ywrys_gQp8Meta } from "/build/b2e7dd14-781e-413a-80e8-55257c207a12/pages/index.vue?macro=true";
import { default as login1P7CgW4Wqmo3By6pHx5rmCwrS9zPrdzYu9r2EutU5ewMeta } from "/build/b2e7dd14-781e-413a-80e8-55257c207a12/pages/login.vue?macro=true";
import { default as mgenvBLyaeIK0oOGmOzgxCEBkzuch2T2EwXpnLv0Hg9NFNUMeta } from "/build/b2e7dd14-781e-413a-80e8-55257c207a12/pages/quiz/mgen.vue?macro=true";
import { default as index02Vu47pidN4R8aqCB7LRu2haQz0uN_459k6o7zNYvYCTYMeta } from "/build/b2e7dd14-781e-413a-80e8-55257c207a12/pages/admin/index.vue?macro=true";
import { default as notesr1wXTw36MJrAKzEM1xg1oZw_453638_FTN41BePaZAgM8Meta } from "/build/b2e7dd14-781e-413a-80e8-55257c207a12/pages/admin/notes.vue?macro=true";
import { default as index_H3A6S8yZWzLL3w2shauVmSp86x_NEbSxp01MBKVsFoMeta } from "/build/b2e7dd14-781e-413a-80e8-55257c207a12/pages/stats/index.vue?macro=true";
import { default as en_45ce_45momentSXIo6OfVx_SVfU4Y0HAqF96XNmlYsiswnsYQBJ5XOssMeta } from "/build/b2e7dd14-781e-413a-80e8-55257c207a12/pages/en-ce-moment.vue?macro=true";
import { default as plan_45du_45siteyef0hHbAuAPLk72NKHvMBPfKjD5lClsQ1An4oS_rzCMMeta } from "/build/b2e7dd14-781e-413a-80e8-55257c207a12/pages/plan-du-site.vue?macro=true";
import { default as edit9NKXZJYEfZvSsFwJ3PyVdJoCBR72E3QaWD6djlnFoz4Meta } from "/build/b2e7dd14-781e-413a-80e8-55257c207a12/pages/profile/edit.vue?macro=true";
import { default as placesKo4VhraX1oYf56rYLGzbrhCHjbBJ9f6YDtcGcvw_45VNcMeta } from "/build/b2e7dd14-781e-413a-80e8-55257c207a12/pages/stats/places.vue?macro=true";
import { default as accessibiliteT8W4wKqywA2xAHatHUM2Qwf2zZDJ6KvFb_45_kqM7YboYMeta } from "/build/b2e7dd14-781e-413a-80e8-55257c207a12/pages/accessibilite.vue?macro=true";
import { default as _91id_93AZxLpLuwFbJiEVUQrRukI_dZr6Z05DFw1faWHWsaoWIMeta } from "/build/b2e7dd14-781e-413a-80e8-55257c207a12/pages/messages/[id].vue?macro=true";
import { default as notificationsiLLqncH_45HHd_4508tfEBaImF59aHff1Pe2Fxnxc4fMZfkMeta } from "/build/b2e7dd14-781e-413a-80e8-55257c207a12/pages/notifications.vue?macro=true";
import { default as indexiFdg4hu5g13N4BbhlRIlubIizzWX1qzwiuYOo4EyHd0Meta } from "/build/b2e7dd14-781e-413a-80e8-55257c207a12/pages/profile/index.vue?macro=true";
import { default as index1FHBYl5KyW_45XRVWozpAK9hfhA0FuMTF_45QSJ2a8Y2wkkMeta } from "/build/b2e7dd14-781e-413a-80e8-55257c207a12/pages/support/index.vue?macro=true";
import { default as _91slug_9331FM_EIMz1iLnAe_45XnkZytA9Hcbf1i4jwAhABDjMvrYMeta } from "/build/b2e7dd14-781e-413a-80e8-55257c207a12/pages/villes/[slug].vue?macro=true";
import { default as indexyNhXG6Xre9SX8CJpUUN_y1LlyI2Jp9qe6xXJCJRx9MkMeta } from "/build/b2e7dd14-781e-413a-80e8-55257c207a12/pages/messages/index.vue?macro=true";
import { default as generiquewqm5tTqHiewpgytV_L5UGNtg87XQUZFMtlrd8N2qx_45UMeta } from "/build/b2e7dd14-781e-413a-80e8-55257c207a12/pages/quiz/generique.vue?macro=true";
import { default as _91slug_93r6cTenugJQdcebhj4e5unPYx0x_NnMj_45K_vn6RkelUAMeta } from "/build/b2e7dd14-781e-413a-80e8-55257c207a12/pages/reseaux/[slug].vue?macro=true";
import { default as missionsiZ0vpjaEhmHntEmKMqXU1f2idu9b6_zM2OlFq5Y2LrMMeta } from "/build/b2e7dd14-781e-413a-80e8-55257c207a12/pages/stats/missions.vue?macro=true";
import { default as indexBRRNDbJJ0Q41Y_zih18bJgmzZ3U39KdAl5yWp1fpe2wMeta } from "/build/b2e7dd14-781e-413a-80e8-55257c207a12/pages/dashboard/index.vue?macro=true";
import { default as favoriskDAM8mm2w3fVh_I6WTeDHPNHD07K1TyXJZ_45tlHwjgH0Meta } from "/build/b2e7dd14-781e-413a-80e8-55257c207a12/pages/profile/favoris.vue?macro=true";
import { default as _91slug_93IH5ibj_dY6HhrvIaQxfZhy7Ey9Yg0W5T7jZ6i3bJto4Meta } from "/build/b2e7dd14-781e-413a-80e8-55257c207a12/pages/activites/[slug].vue?macro=true";
import { default as logs65eJ_45OgHQTGpd_vV_NN5L5yl7WUAK9cvTmP7CIPMeVMMeta } from "/build/b2e7dd14-781e-413a-80e8-55257c207a12/pages/admin/other/logs.vue?macro=true";
import { default as ressourceshP1NdzDotQR0CQXVCPwt9sqqA86fpM45O01CJrBr1rMMeta } from "/build/b2e7dd14-781e-413a-80e8-55257c207a12/pages/admin/ressources.vue?macro=true";
import { default as mentions_45legalesvg_45GK7OW_LeD5pxH_RyqDzvFFDBsvrXhD3oshOpXsdcMeta } from "/build/b2e7dd14-781e-413a-80e8-55257c207a12/pages/mentions-legales.vue?macro=true";
import { default as missionsPqR9Dpv6dT4gg3BvEGPK5yK_45vcFVwtvgYwyMeWEiYXoMeta } from "/build/b2e7dd14-781e-413a-80e8-55257c207a12/pages/profile/missions.vue?macro=true";
import { default as settingsF07DjEts6qqQxrN2Z3vBnkBwxiJCHeCTGqg8U5HtJ_45kMeta } from "/build/b2e7dd14-781e-413a-80e8-55257c207a12/pages/profile/settings.vue?macro=true";
import { default as temoignagesWiQgh7ybe_otsG1w3HabV8wtpCkqPewrfh_HKeh_u6QMeta } from "/build/b2e7dd14-781e-413a-80e8-55257c207a12/pages/admin/temoignages.vue?macro=true";
import { default as index6RHNc1mGzShcHM6jtAragOmYQMRgkWc9_yBnUfQgMxgMeta } from "/build/b2e7dd14-781e-413a-80e8-55257c207a12/pages/inscription/index.vue?macro=true";
import { default as adminCom3hg5SH1nUJtNJq4SGd_45UfeOiMDqYI1Qr_45kTBWGIoMeta } from "/build/b2e7dd14-781e-413a-80e8-55257c207a12/pages/maintenance/admin.vue?macro=true";
import { default as index7wKvx5t634ZeRMykL5i_45eL7b1OYP_W9H0wQFxWPxyqgMeta } from "/build/b2e7dd14-781e-413a-80e8-55257c207a12/pages/maintenance/index.vue?macro=true";
import { default as indexb9s_lxo4PmbT39aKZEKTIRJbBOLAazAhDOX3gvQd1TwMeta } from "/build/b2e7dd14-781e-413a-80e8-55257c207a12/pages/territoires/index.vue?macro=true";
import { default as _91hash_93bRwNm98l1ZJYUrWI2VIV51fc7fdsHrrEUysZtT97awMMeta } from "/build/b2e7dd14-781e-413a-80e8-55257c207a12/pages/invitations/[hash].vue?macro=true";
import { default as utilisateursovuGWa6AEOPKKaQUBYpZmJ6XzOappUDNNDWeBHWz_45b4Meta } from "/build/b2e7dd14-781e-413a-80e8-55257c207a12/pages/stats/utilisateurs.vue?macro=true";
import { default as _91slug_93RKGIbCFi_457qMxn2CkwXTpIkbd3Yfm2j0MjS3Gxw6DNMMeta } from "/build/b2e7dd14-781e-413a-80e8-55257c207a12/pages/associations/[slug].vue?macro=true";
import { default as _91slug_93yQpXj6PxW2RA_50nDDI2kFozaKPkOydLdI_457sf6b7qgMeta } from "/build/b2e7dd14-781e-413a-80e8-55257c207a12/pages/departements/[slug].vue?macro=true";
import { default as indexEc7X71_45cVv0u4_sr9peC2dpRE3SsRc48kRYafWaEo9gMeta } from "/build/b2e7dd14-781e-413a-80e8-55257c207a12/pages/organisations/index.vue?macro=true";
import { default as preferencestlRY3v5yF_45JAHYwT_j1BlD0VLvRwf3yLxgZqiik8K_UMeta } from "/build/b2e7dd14-781e-413a-80e8-55257c207a12/pages/profile/preferences.vue?macro=true";
import { default as organisations95LcZqlSdndgMITWF3pNHxZVDIPwv3iSkGjInokN2ioMeta } from "/build/b2e7dd14-781e-413a-80e8-55257c207a12/pages/stats/organisations.vue?macro=true";
import { default as _91token_93lQWglrtvgP19br8AMpb8Qr_456hrzT0EFn_45oE2_H5aXB4Meta } from "/build/b2e7dd14-781e-413a-80e8-55257c207a12/pages/temoignages/[token].vue?macro=true";
import { default as postsB6AQCa_CoX_VKrdd_p_45K0g6oypiGJPEPyvFO8vUbGygMeta } from "/build/b2e7dd14-781e-413a-80e8-55257c207a12/pages/admin/contenus/posts.vue?macro=true";
import { default as indexB6hdaQA4D1A_dnwhbVytmBOqe5QbmWvjMka_45nSdR_45OEMeta } from "/build/b2e7dd14-781e-413a-80e8-55257c207a12/pages/admin/missions/index.vue?macro=true";
import { default as addzaitybMH7r3_EIEsZ_WzaJPBtumLIgAqdjnUcGbNvdsMeta } from "/build/b2e7dd14-781e-413a-80e8-55257c207a12/pages/messages/modeles/add.vue?macro=true";
import { default as _91slug_93pUT3rVXiOCvXsfbuSu6aWz2u9OOvbB5sOBE5MvPm_45IQMeta } from "/build/b2e7dd14-781e-413a-80e8-55257c207a12/pages/organisations/[slug].vue?macro=true";
import { default as indexC4SXzIylD74_o8oJ_458FN7ouXa_DpfaBZ0uMFa_45fU5_45wMeta } from "/build/b2e7dd14-781e-413a-80e8-55257c207a12/pages/password-reset/index.vue?macro=true";
import { default as participationsdqKR1Kw3FV2OJCRVEzXIgCLN7biDr5SlCu_EHa3R6UUMeta } from "/build/b2e7dd14-781e-413a-80e8-55257c207a12/pages/stats/participations.vue?macro=true";
import { default as emailsBcHrA7yzztTH3IiOI48tDvg2DcYcCQFT5VIpotSileIMeta } from "/build/b2e7dd14-781e-413a-80e8-55257c207a12/pages/admin/settings/emails.vue?macro=true";
import { default as indexF48mdBPxvjmyYR5PT9awNNSl1VSBOajkAh6RPKvqasEMeta } from "/build/b2e7dd14-781e-413a-80e8-55257c207a12/pages/profile/alertes/index.vue?macro=true";
import { default as notificationsbn4YBGkpdDCEAbv6Ge1c_VE9wrEw_h_45af_QONXxT_45HYMeta } from "/build/b2e7dd14-781e-413a-80e8-55257c207a12/pages/profile/notifications.vue?macro=true";
import { default as indexWATWXHt5_S9qcn8MPRV4b6a2rUmakmpA8YROsHp_45ATkMeta } from "/build/b2e7dd14-781e-413a-80e8-55257c207a12/pages/admin/statistics/index.vue?macro=true";
import { default as charte_45reserve_45civiqueWILBxxapr9OOwbQK7oaly1FWKOmeDZA1wszXqVWInhoMeta } from "/build/b2e7dd14-781e-413a-80e8-55257c207a12/pages/charte-reserve-civique.vue?macro=true";
import { default as _91slug_93r2m_45qSKJksmPSm2D5EHuStp6j8jxQwOKkta8Ew88MOwMeta } from "/build/b2e7dd14-781e-413a-80e8-55257c207a12/pages/domaines-action/[slug].vue?macro=true";
import { default as indexTxZC73jlp8tQ1WAmaQQz2onFiY2SpAWztTfRnYH6WkUMeta } from "/build/b2e7dd14-781e-413a-80e8-55257c207a12/pages/messages/modeles/index.vue?macro=true";
import { default as _91token_93XFePyPZWCVKNX9MX2T6Vp5qFjercz0JgJpc1XGPv4LwMeta } from "/build/b2e7dd14-781e-413a-80e8-55257c207a12/pages/password-reset/[token].vue?macro=true";
import { default as decembre_45ensembletEll_5bvJLnXepWNcAH_45nACdZd8meIdfcEmfUhbdNnQMeta } from "/build/b2e7dd14-781e-413a-80e8-55257c207a12/pages/quiz/decembre-ensemble.vue?macro=true";
import { default as invitationshb_K3W7g9POPBRA_9WHetj0Nhvic3knXKC7_4528mMdRkMeta } from "/build/b2e7dd14-781e-413a-80e8-55257c207a12/pages/admin/other/invitations.vue?macro=true";
import { default as messagesVONfNjTcqqN8Ed6fHjY6IRUIdHIGlDIgsx3brSs2M1MMeta } from "/build/b2e7dd14-781e-413a-80e8-55257c207a12/pages/admin/settings/messages.vue?macro=true";
import { default as placesPLRWbl9d6W_EhiGXuZCVe8ppo2LrFneI7gquKSmsH5MMeta } from "/build/b2e7dd14-781e-413a-80e8-55257c207a12/pages/admin/statistics/places.vue?macro=true";
import { default as addONlmDfsSQ_hqwNUUi2dZfqNNvbuc912xo2rkLqxty7QMeta } from "/build/b2e7dd14-781e-413a-80e8-55257c207a12/pages/admin/settings/rules/add.vue?macro=true";
import { default as indexG1Bz5yxexgB325aFGmwI8TyJaXuRLgWIWylLxkjq27sMeta } from "/build/b2e7dd14-781e-413a-80e8-55257c207a12/pages/admin/utilisateurs/index.vue?macro=true";
import { default as index30IPpk_IXKVPqfV9nHzvRgDl8WrYmfXfi6dDzxzpUjYMeta } from "/build/b2e7dd14-781e-413a-80e8-55257c207a12/pages/missions-benevolat/index.vue?macro=true";
import { default as datessn8RE2jaYTYYhP6o2qv188BvtxQ5IniYGZIxVr_5LtIMeta } from "/build/b2e7dd14-781e-413a-80e8-55257c207a12/pages/admin/missions/[id]/dates.vue?macro=true";
import { default as indexhLpSiLKzVzd22tLUtE_45XDrm5sKtc0iyWxXdSaTqP4IcMeta } from "/build/b2e7dd14-781e-413a-80e8-55257c207a12/pages/admin/missions/[id]/index.vue?macro=true";
import { default as lieuxAAax56JiHAz0vpRIpu_45iv32AcAARpG0s9Om5DezrYVoMeta } from "/build/b2e7dd14-781e-413a-80e8-55257c207a12/pages/admin/missions/[id]/lieux.vue?macro=true";
import { default as titleBcuJF1q_89uALNrmewJdHGy3p6dpKPp575olNcvJENsMeta } from "/build/b2e7dd14-781e-413a-80e8-55257c207a12/pages/admin/missions/[id]/title.vue?macro=true";
import { default as indexIVuvx66N8r_PcfnsJOjPl6QsPTHwbaXgqCyXCya61uoMeta } from "/build/b2e7dd14-781e-413a-80e8-55257c207a12/pages/admin/organisations/index.vue?macro=true";
import { default as missionsbPOrakYL_45kqHc_45NsciHKIsFJOEyg1INVoYn0v_45J_45QJIMeta } from "/build/b2e7dd14-781e-413a-80e8-55257c207a12/pages/admin/statistics/missions.vue?macro=true";
import { default as adds_456OYsaNv9yGTqgZsj_UrNK8y4oXLgEeui4bPy2jl_wMeta } from "/build/b2e7dd14-781e-413a-80e8-55257c207a12/pages/admin/contenus/reseaux/add.vue?macro=true";
import { default as visueldctYqH32RaF5SGO9JXAMPNovLLwaeCxc64jI8KHSzMEMeta } from "/build/b2e7dd14-781e-413a-80e8-55257c207a12/pages/admin/missions/[id]/visuel.vue?macro=true";
import { default as indexqLX1Cb766fz2FwNDzMkvT6S_cQhislTFORO_45MkiaoCcMeta } from "/build/b2e7dd14-781e-413a-80e8-55257c207a12/pages/admin/participations/index.vue?macro=true";
import { default as indexatuBGjmjgAu2u7QiWavE0HxJjBt_yEH1evlfsB_45Q00oMeta } from "/build/b2e7dd14-781e-413a-80e8-55257c207a12/pages/admin/settings/rules/index.vue?macro=true";
import { default as indexgI3l2Ikhdi_B_XW7FJDYj0acAu1j6Uuxio8lXc3amJsMeta } from "/build/b2e7dd14-781e-413a-80e8-55257c207a12/pages/inscription/benevole/index.vue?macro=true";
import { default as addaKnIgpTl2LXQYBjHI_45ZmYakdqfzrObkThlA_f_TcXd0Meta } from "/build/b2e7dd14-781e-413a-80e8-55257c207a12/pages/admin/contenus/domaines/add.vue?macro=true";
import { default as addvNasyxhdHP_45fsoAx5WELIAXAExTxwEB8d6FnQstxgUkMeta } from "/build/b2e7dd14-781e-413a-80e8-55257c207a12/pages/admin/taxonomies/[slug]/add.vue?macro=true";
import { default as addsKvY9Q8DGu9yHvlS24Gbfjt9hlge_Rpw_WUyT6JkfiQMeta } from "/build/b2e7dd14-781e-413a-80e8-55257c207a12/pages/admin/contenus/activites/add.vue?macro=true";
import { default as indexH0GurariLtoMyw8m34iMIODnbhPS_45LrnMa0dqFetZeEMeta } from "/build/b2e7dd14-781e-413a-80e8-55257c207a12/pages/admin/contenus/reseaux/index.vue?macro=true";
import { default as conversions3javaxQNab8YArdsVp83sWUCMJuIJZJ17CRGBdMCpgsMeta } from "/build/b2e7dd14-781e-413a-80e8-55257c207a12/pages/admin/statistics/conversions.vue?macro=true";
import { default as edit9_45zSUWotN0h3ZyHJc3829az9dyCrMfIpka1dQRDykWIMeta } from "/build/b2e7dd14-781e-413a-80e8-55257c207a12/pages/admin/utilisateurs/[id]/edit.vue?macro=true";
import { default as politique_45de_45confidentialitebeKwgiMZBiWKQcusPPSZOzqNSa5lW9ExIvCM8_8c3msMeta } from "/build/b2e7dd14-781e-413a-80e8-55257c207a12/pages/politique-de-confidentialite.vue?macro=true";
import { default as indextIdvnt3xxKUkA8ZmNemsiUtNOeOynUHdKhgHWocUz7wMeta } from "/build/b2e7dd14-781e-413a-80e8-55257c207a12/pages/admin/contenus/domaines/index.vue?macro=true";
import { default as addRtgk4gSxgBn5Z1T0SQ_45rElLlyf2fJveeFFMwVThSjDAMeta } from "/build/b2e7dd14-781e-413a-80e8-55257c207a12/pages/admin/contenus/ressources/add.vue?macro=true";
import { default as benevoles6hx2MIjDeDt_45FPgqH56i_45F0Ctz0z43itNgexU7EM8pcMeta } from "/build/b2e7dd14-781e-413a-80e8-55257c207a12/pages/admin/missions/[id]/benevoles.vue?macro=true";
import { default as editooAm601KgjJ3oJRlBmE4cRfB3amHcJG_RHCB_jJVuMQMeta } from "/build/b2e7dd14-781e-413a-80e8-55257c207a12/pages/admin/organisations/[id]/edit.vue?macro=true";
import { default as utilisateursL8bqoqLvz6oSFE7hO1MQtSDadPwJwoYX3_450__bPpFcMMeta } from "/build/b2e7dd14-781e-413a-80e8-55257c207a12/pages/admin/statistics/utilisateurs.vue?macro=true";
import { default as indexuHSPn649NC3T2WnCoA4dAljYZYHws_PrQdxERFQigmgMeta } from "/build/b2e7dd14-781e-413a-80e8-55257c207a12/pages/admin/taxonomies/[slug]/index.vue?macro=true";
import { default as indexP8_3RrAejkitEtellE0vtK_nT3S65JqYVkaWksjkgfsMeta } from "/build/b2e7dd14-781e-413a-80e8-55257c207a12/pages/admin/utilisateurs/[id]/index.vue?macro=true";
import { default as indexlrqNufYkXbPY_45W9Ii27kya6RxafJsrIhp9tpNsWK_45eYMeta } from "/build/b2e7dd14-781e-413a-80e8-55257c207a12/pages/inscription/responsable/index.vue?macro=true";
import { default as indexQ4EhAf5VSs7QgxJrvmdAFXnJLvd5sKomrbL2LOpMkOMMeta } from "/build/b2e7dd14-781e-413a-80e8-55257c207a12/pages/missions-benevolat/[id]/index.vue?macro=true";
import { default as septembre_45pour_45apprendreRyyX9zLxqbe8FmvCuDBpvrDn2Fp_JGWXSn26WsDvnpkMeta } from "/build/b2e7dd14-781e-413a-80e8-55257c207a12/pages/quiz/septembre-pour-apprendre.vue?macro=true";
import { default as indexmQMT30uneSPfK02tJxFN_YKsoO9nmpZWA2D_S8XiCNoMeta } from "/build/b2e7dd14-781e-413a-80e8-55257c207a12/pages/admin/contenus/activites/index.vue?macro=true";
import { default as addcCAL7Y4ZVgCGSceXmo0OAbOcPz9Dmt_457PEOUubz8gWcMeta } from "/build/b2e7dd14-781e-413a-80e8-55257c207a12/pages/admin/contenus/territoires/add.vue?macro=true";
import { default as indexW2Zk0JuTfU2s752qG7gNukqL70jY17ltFazlODAntOIMeta } from "/build/b2e7dd14-781e-413a-80e8-55257c207a12/pages/admin/organisations/[id]/index.vue?macro=true";
import { default as editTllQgONizvADaJNrpnBF6uQGfGquCOM8tjdGpOgd9Q0Meta } from "/build/b2e7dd14-781e-413a-80e8-55257c207a12/pages/admin/settings/rules/[id]/edit.vue?macro=true";
import { default as _91slug_93JKlyHneqJuRFgjUHzOyFp_qMZshumAwhH1RvMEYkBNMMeta } from "/build/b2e7dd14-781e-413a-80e8-55257c207a12/pages/missions-benevolat/[id]/[slug].vue?macro=true";
import { default as printemps_45pour_45la_45planetetF8MvxIqWsqSST5PA8DJGjKWkrRe5_45SVGrcRD0SYU44Meta } from "/build/b2e7dd14-781e-413a-80e8-55257c207a12/pages/quiz/printemps-pour-la-planete.vue?macro=true";
import { default as indexp_j9kiQXtwy389_qvW5baQTiN_451SKXarYxxmIyPvM7oMeta } from "/build/b2e7dd14-781e-413a-80e8-55257c207a12/pages/admin/contenus/ressources/index.vue?macro=true";
import { default as participationsOpDZfhuQy4MEJ9cT_45IehTK1zx_DvdUx_45ALuKxwAXtPgMeta } from "/build/b2e7dd14-781e-413a-80e8-55257c207a12/pages/admin/statistics/participations.vue?macro=true";
import { default as indexPMqgeEdDZgqBYICQxOsr_m041VvXKYVXH8dGm7ydV48Meta } from "/build/b2e7dd14-781e-413a-80e8-55257c207a12/pages/charte-bon-fonctionnement/index.vue?macro=true";
import { default as activity_45logsW9SFviD7wKelCqZJ5VMvTc1RABMfQBVhu2Yfo6ARyDMMeta } from "/build/b2e7dd14-781e-413a-80e8-55257c207a12/pages/support/referents/activity-logs.vue?macro=true";
import { default as editSs_JcTwgqSb8zusziOWkd90iVHNHcm2iRCkOKUsIsEQMeta } from "/build/b2e7dd14-781e-413a-80e8-55257c207a12/pages/admin/contenus/reseaux/[id]/edit.vue?macro=true";
import { default as indexQoKD68tXPTIKstJkKRpYxkjoMCLd_AiDGgP5SZEBAtwMeta } from "/build/b2e7dd14-781e-413a-80e8-55257c207a12/pages/admin/contenus/territoires/index.vue?macro=true";
import { default as informationsAe6yk9cMaht1nEbs0F_6qbrbFGkZk4gXIuqYQcvNr70Meta } from "/build/b2e7dd14-781e-413a-80e8-55257c207a12/pages/admin/missions/[id]/informations.vue?macro=true";
import { default as responsablesa9oIFnfmsRc2bkCoKl6jy_pTrfEXi8jRjVTDr67C87wMeta } from "/build/b2e7dd14-781e-413a-80e8-55257c207a12/pages/admin/missions/[id]/responsables.vue?macro=true";
import { default as edit6xRMdID7kBHcIeJTjuNRXCx_45ijkWbhBy_I8FT1CE5lgMeta } from "/build/b2e7dd14-781e-413a-80e8-55257c207a12/pages/admin/contenus/domaines/[id]/edit.vue?macro=true";
import { default as indexWoY39jeXcO1P5OylGJcp_4563nayPdySJVTDQdsyRQaTUMeta } from "/build/b2e7dd14-781e-413a-80e8-55257c207a12/pages/admin/contenus/reseaux/[id]/index.vue?macro=true";
import { default as index2plzhDquWlvk8uAxGlKi_TKLZl9B2y4ORfzxG4aawEcMeta } from "/build/b2e7dd14-781e-413a-80e8-55257c207a12/pages/admin/contenus/testimonials/index.vue?macro=true";
import { default as indicateurs_45cles7D_45oZDAZg6A4kYNfT0SzR2vOY1YaFeTuiZijnthMZlUMeta } from "/build/b2e7dd14-781e-413a-80e8-55257c207a12/pages/admin/statistics/indicateurs-cles.vue?macro=true";
import { default as edit_O_pSIexwcsuPdFAUn7_454yK3VzsHghgBh8omJLG0sZgMeta } from "/build/b2e7dd14-781e-413a-80e8-55257c207a12/pages/admin/taxonomies/[slug]/[id]/edit.vue?macro=true";
import { default as profilen_HZlgbD51JLLcq7zRRAVCseOLCcTYTIVQF0beoY7ZAMeta } from "/build/b2e7dd14-781e-413a-80e8-55257c207a12/pages/inscription/benevole/step/profile.vue?macro=true";
import { default as charte_45bon_45fonctionnementy_45x6pDu6qSjMtyxlbe1GOaNUuVbUu9UlXgCFGWU2XMcMeta } from "/build/b2e7dd14-781e-413a-80e8-55257c207a12/pages/profile/charte-bon-fonctionnement.vue?macro=true";
import { default as waiting_45actionsiRcHuRX1xYjTCqOA8zNHcJ7B8XbCPJUUP90Op1RhnDwMeta } from "/build/b2e7dd14-781e-413a-80e8-55257c207a12/pages/support/referents/waiting-actions.vue?macro=true";
import { default as edit0kBcqsREAE0Zxsij9M18hVWoLcMnJ4CLnsjoTciSQZgMeta } from "/build/b2e7dd14-781e-413a-80e8-55257c207a12/pages/admin/contenus/activites/[id]/edit.vue?macro=true";
import { default as addDksily7wM4VRj1Y7P6pBRPXuqWey2QVMdD7OuJdiNkwMeta } from "/build/b2e7dd14-781e-413a-80e8-55257c207a12/pages/admin/contenus/modeles-mission/add.vue?macro=true";
import { default as conditions_45generales_45d_45utilisationt2Tc567NtWJ3_456XdueJsDCSheReyMeHx0gJkLxDenZUMeta } from "/build/b2e7dd14-781e-413a-80e8-55257c207a12/pages/conditions-generales-d-utilisation.vue?macro=true";
import { default as indexGgrmtGVgSouywwLxGKpPZ8_45xmuuQTenBeLkzdlih2T8Meta } from "/build/b2e7dd14-781e-413a-80e8-55257c207a12/pages/admin/contenus/activites/[id]/index.vue?macro=true";
import { default as edit41o5WIlJ35FaWrE5jAlQt2MXdVZEEJG7yRE_458Bi3MBsMeta } from "/build/b2e7dd14-781e-413a-80e8-55257c207a12/pages/admin/contenus/ressources/[id]/edit.vue?macro=true";
import { default as diffusionsYJplRwaUp41PI5kWheGZlpd6omzIod6IglbNaekMJYwMeta } from "/build/b2e7dd14-781e-413a-80e8-55257c207a12/pages/admin/organisations/[id]/diffusions.vue?macro=true";
import { default as moderationsubpWFfPAqc2_45fH3bPTs2froFgxxIJiGdsLgPH1NFaEQMeta } from "/build/b2e7dd14-781e-413a-80e8-55257c207a12/pages/admin/statistics/suivis/moderations.vue?macro=true";
import { default as benevolesVEgsVSmT9QL9nTQ7biQAjuGyfIQJ19yp1QG6xMIeJT8Meta } from "/build/b2e7dd14-781e-413a-80e8-55257c207a12/pages/charte-bon-fonctionnement/benevoles.vue?macro=true";
import { default as google_45api_45indexingftBbKMLPOgcLHu2eGPFPe3bNhBEJW9TsAi65WjVli_45AMeta } from "/build/b2e7dd14-781e-413a-80e8-55257c207a12/pages/support/actions/google-api-indexing.vue?macro=true";
import { default as indexj_45Ssr3O3RhGmb6agd6ZVRatDVHTVl68HKlfVfyq_45YhgMeta } from "/build/b2e7dd14-781e-413a-80e8-55257c207a12/pages/admin/contenus/modeles-mission/index.vue?macro=true";
import { default as edit7xIB_Sh9Nud_45ssTkXof8NnMkizNsBYwhvLGw30CVRT8Meta } from "/build/b2e7dd14-781e-413a-80e8-55257c207a12/pages/admin/contenus/territoires/[id]/edit.vue?macro=true";
import { default as indexI4k_45ontIQGr2S2sHeZI_UtTpKTFfxKxa213xk14iRF4Meta } from "/build/b2e7dd14-781e-413a-80e8-55257c207a12/pages/admin/statistics/organisations/index.vue?macro=true";
import { default as profile_45ZTFPyOuePS_45VXsLVipDNmBMiQVCL9lwBMZiW4HT6zgMeta } from "/build/b2e7dd14-781e-413a-80e8-55257c207a12/pages/inscription/responsable/step/profile.vue?macro=true";
import { default as indexzw9S6_45oBRpl8Tg85BWxSVLuJFxsvCNGnkTLhpI3Gd8oMeta } from "/build/b2e7dd14-781e-413a-80e8-55257c207a12/pages/admin/contenus/territoires/[id]/index.vue?macro=true";
import { default as editlmvoWqesFGB_bCKUPSsPnNPavH3tL_sEJs7gy_Ji_EEMeta } from "/build/b2e7dd14-781e-413a-80e8-55257c207a12/pages/admin/contenus/testimonials/[id]/edit.vue?macro=true";
import { default as addd4PANeJc5CWwZQIGO6ghOJIT3bX9eJ_B9aPa5PnyNVQMeta } from "/build/b2e7dd14-781e-413a-80e8-55257c207a12/pages/admin/organisations/[id]/missions/add.vue?macro=true";
import { default as competencestc2X_454xmTlybYIihoZDZeo0RMe8DWPZsYNk_45_45d1OxfoMeta } from "/build/b2e7dd14-781e-413a-80e8-55257c207a12/pages/inscription/benevole/step/competences.vue?macro=true";
import { default as preferencesq9udvL5R9V3mqIp4maQ_45jzTGEaxtRLIDYcWt1mpRrWIMeta } from "/build/b2e7dd14-781e-413a-80e8-55257c207a12/pages/inscription/benevole/step/preferences.vue?macro=true";
import { default as search_45archived_45usersEv2o3p0d7_45bpjzmCgLMLT3fbq6gyN2XSAlPjQUIokOgMeta } from "/build/b2e7dd14-781e-413a-80e8-55257c207a12/pages/support/actions/search-archived-users.vue?macro=true";
import { default as doublons_45territoiresXzejZz1JjBWaGC5o_aUagEtXzaIuutCuDqTcxAXxNYcMeta } from "/build/b2e7dd14-781e-413a-80e8-55257c207a12/pages/support/contents/doublons-territoires.vue?macro=true";
import { default as responsables8AUOQ7pbQ7dXhPz0kjvWBIMdRBLWxHpoIzG9h25Oj5YMeta } from "/build/b2e7dd14-781e-413a-80e8-55257c207a12/pages/charte-bon-fonctionnement/responsables.vue?macro=true";
import { default as transfert_45organisationoMOPfl2vUeZzx223PqciI3HTZKqOt2_45Csr_45eNBv_45k9kMeta } from "/build/b2e7dd14-781e-413a-80e8-55257c207a12/pages/support/actions/transfert-organisation.vue?macro=true";
import { default as missions_45outdatedeUH4LuP51G6HvXZZ5D86mfhREoZdCInjypWs_mCFS_45kMeta } from "/build/b2e7dd14-781e-413a-80e8-55257c207a12/pages/support/responsables/missions-outdated.vue?macro=true";
import { default as pending_45itemsYjCotMM_r5SywTphfl9KHgFzBESFDSK1oEVZHdNVEGgMeta } from "/build/b2e7dd14-781e-413a-80e8-55257c207a12/pages/admin/settings/rules/[id]/pending-items.vue?macro=true";
import { default as user_45reset_45context_45rolejP5j_45J9yI8a6GXCywgDRx8d3Z6UBBffdahwpupFO16UMeta } from "/build/b2e7dd14-781e-413a-80e8-55257c207a12/pages/support/actions/user-reset-context-role.vue?macro=true";
import { default as doublons_45organisationsf8dKlKUYGYts4zHhgPAavPim_45d6zrIQfBCozauxttywMeta } from "/build/b2e7dd14-781e-413a-80e8-55257c207a12/pages/support/contents/doublons-organisations.vue?macro=true";
import { default as editemF9vpSvLJZrkJ_EmxGctrsIuGavKSJwiDHHk8iGlVMMeta } from "/build/b2e7dd14-781e-413a-80e8-55257c207a12/pages/admin/contenus/modeles-mission/[id]/edit.vue?macro=true";
import { default as disponibilitesjchVzjESCJjgigccuMrIjCpLm0ZuTjMACaqJ_5EJqpMMeta } from "/build/b2e7dd14-781e-413a-80e8-55257c207a12/pages/inscription/benevole/step/disponibilites.vue?macro=true";
import { default as user_45reset_45password_45linkLvOWCF2UjD8psCENThvBk_45vwMgJviIny3mOSYOSuxccMeta } from "/build/b2e7dd14-781e-413a-80e8-55257c207a12/pages/support/actions/user-reset-password-link.vue?macro=true";
import { default as indexFda8OTUQgGOEAQUd1_5qYNl68dBzvlo3uFv_DPGPxIEMeta } from "/build/b2e7dd14-781e-413a-80e8-55257c207a12/pages/admin/contenus/modeles-mission/[id]/index.vue?macro=true";
import { default as collectiviteGfphakMYbJZHsorFCGIPtjPQrgPWscBplTR9fzEgi0wMeta } from "/build/b2e7dd14-781e-413a-80e8-55257c207a12/pages/inscription/responsable/step/collectivite.vue?macro=true";
import { default as organisation7PViXDCOaoCsclqZaRR2xTsGJkjPTI6tNVwfmhiCKH4Meta } from "/build/b2e7dd14-781e-413a-80e8-55257c207a12/pages/inscription/responsable/step/organisation.vue?macro=true";
import { default as benevoles_45informationsZ0QZ9V2kHDg7BRNFCWJ7_450cV4NX6bXiq0QSFH1zB6P4Meta } from "/build/b2e7dd14-781e-413a-80e8-55257c207a12/pages/admin/missions/[id]/benevoles-informations.vue?macro=true";
import { default as trafic_45entrantwVPGCiIWY_F2ZpqDpSkQ_HYlQ6FejyLdn_60VPMdwXIMeta } from "/build/b2e7dd14-781e-413a-80e8-55257c207a12/pages/admin/statistics/api-engagement/trafic-entrant.vue?macro=true";
import { default as trafic_45sortantqCrT8JR9VkLLqGIzY69H5q_45xP9Axi53CyNiWzYVkYpgMeta } from "/build/b2e7dd14-781e-413a-80e8-55257c207a12/pages/admin/statistics/api-engagement/trafic-sortant.vue?macro=true";
import { default as indexoc_45ZFCaVckU72ti8P1Irob4LpfFtKaPFgaMs35s_45OHkMeta } from "/build/b2e7dd14-781e-413a-80e8-55257c207a12/pages/admin/missions/[id]/trouver-des-benevoles/index.vue?macro=true";
import { default as missions_45perimeescITXl8VhN7UqENqUM3bMLkUhGyIzTiH8XAjfWNFF6vUMeta } from "/build/b2e7dd14-781e-413a-80e8-55257c207a12/pages/admin/statistics/departements/missions-perimees.vue?macro=true";
import { default as missions_45a_45validerrjLC0EbrMXqqH3eduzE0GpS4axLDD4OWczWDnUkMWb4Meta } from "/build/b2e7dd14-781e-413a-80e8-55257c207a12/pages/admin/statistics/departements/missions-a-valider.vue?macro=true";
import { default as missions_45perimeesRjcECZoi3wDihN7LIG4_YmCauuBTs9GKMww7nrXoieAMeta } from "/build/b2e7dd14-781e-413a-80e8-55257c207a12/pages/admin/statistics/organisations/missions-perimees.vue?macro=true";
import { default as organisation_45imageswJ41C9iaLwVPp6uaZPFGuiqWRlH53oETSi3dHtO1AG0Meta } from "/build/b2e7dd14-781e-413a-80e8-55257c207a12/pages/inscription/responsable/step/organisation-images.vue?macro=true";
import { default as organisation_45detailsRZVCVmfHuxuFCXZLhwt0FZMa6_454_45tUUiPQnB35JIcpoMeta } from "/build/b2e7dd14-781e-413a-80e8-55257c207a12/pages/inscription/responsable/step/organisation-details.vue?macro=true";
import { default as participations_45to_45be_45treatedy7X_iX7wf4gnNmfaGcQhx7AK_Ev3vveq571zQm1OU2wMeta } from "/build/b2e7dd14-781e-413a-80e8-55257c207a12/pages/support/responsables/participations-to-be-treated.vue?macro=true";
import { default as redirectgrR8q27LgAssj_45SHs0BC8hn7hlbFLdYXyDhZtRBe9loMeta } from "/build/b2e7dd14-781e-413a-80e8-55257c207a12/pages/admin/missions/[id]/trouver-des-benevoles/redirect.vue?macro=true";
import { default as organisations_45a_45valider00ke6Q1bBALifXNjAia_454p2ELQxLNYb5Saoazj0HbVgMeta } from "/build/b2e7dd14-781e-413a-80e8-55257c207a12/pages/admin/statistics/departements/organisations-a-valider.vue?macro=true";
import { default as charte_45bon_45fonctionnement9vlQgXfqPfHpv2U8J7XIzHiVToR2UkFSY24dFm7N_kUMeta } from "/build/b2e7dd14-781e-413a-80e8-55257c207a12/pages/inscription/responsable/step/charte-bon-fonctionnement.vue?macro=true";
import { default as collectivite_45confirmation9weWCMZjNI7VlxDSKfblNGpTyaCVDx0kAYt9MJu0UUMMeta } from "/build/b2e7dd14-781e-413a-80e8-55257c207a12/pages/inscription/responsable/step/collectivite-confirmation.vue?macro=true";
import { default as organisation_45confirmationUjfvqLA8vHcoKUfTFJ8_gethIQJwj6CTb7GRgQRVTUIMeta } from "/build/b2e7dd14-781e-413a-80e8-55257c207a12/pages/inscription/responsable/step/organisation-confirmation.vue?macro=true";
import { default as participations_45a_45validervZ_45_N9nw2N9YIcRw7aEss76SwpcAJ_45qdje9vMv9RBDEMeta } from "/build/b2e7dd14-781e-413a-80e8-55257c207a12/pages/admin/statistics/organisations/participations-a-valider.vue?macro=true";
import { default as participations_45refusees_45annulees6F4dAt7Lt3oWcdoqyeNU6jngrgMy9nM_O35GCEl69VwMeta } from "/build/b2e7dd14-781e-413a-80e8-55257c207a12/pages/admin/statistics/organisations/participations-refusees-annulees.vue?macro=true";
import { default as component_45stubwnIIvCymbsetrhMzSN4UqivqhDWgXlKt7052s85uwYYMeta } from "/build/b2e7dd14-781e-413a-80e8-55257c207a12/node_modules/nuxt/dist/pages/runtime/component-stub.js?macro=true";
import { default as component_45stubwnIIvCymbsetrhMzSN4UqivqhDWgXlKt7052s85uwYY } from "/build/b2e7dd14-781e-413a-80e8-55257c207a12/node_modules/nuxt/dist/pages/runtime/component-stub.js";
export default [
  {
    name: "index",
    path: "/",
    component: () => import("/build/b2e7dd14-781e-413a-80e8-55257c207a12/pages/index.vue")
  },
  {
    name: "login",
    path: "/login",
    meta: login1P7CgW4Wqmo3By6pHx5rmCwrS9zPrdzYu9r2EutU5ewMeta || {},
    component: () => import("/build/b2e7dd14-781e-413a-80e8-55257c207a12/pages/login.vue")
  },
  {
    name: "quiz-mgen",
    path: "/quiz/mgen",
    meta: mgenvBLyaeIK0oOGmOzgxCEBkzuch2T2EwXpnLv0Hg9NFNUMeta || {},
    component: () => import("/build/b2e7dd14-781e-413a-80e8-55257c207a12/pages/quiz/mgen.vue")
  },
  {
    name: "admin",
    path: "/admin",
    meta: index02Vu47pidN4R8aqCB7LRu2haQz0uN_459k6o7zNYvYCTYMeta || {},
    component: () => import("/build/b2e7dd14-781e-413a-80e8-55257c207a12/pages/admin/index.vue")
  },
  {
    name: "admin-notes",
    path: "/admin/notes",
    meta: notesr1wXTw36MJrAKzEM1xg1oZw_453638_FTN41BePaZAgM8Meta || {},
    component: () => import("/build/b2e7dd14-781e-413a-80e8-55257c207a12/pages/admin/notes.vue")
  },
  {
    name: "stats",
    path: "/stats",
    meta: index_H3A6S8yZWzLL3w2shauVmSp86x_NEbSxp01MBKVsFoMeta || {},
    component: () => import("/build/b2e7dd14-781e-413a-80e8-55257c207a12/pages/stats/index.vue")
  },
  {
    name: "en-ce-moment",
    path: "/en-ce-moment",
    component: () => import("/build/b2e7dd14-781e-413a-80e8-55257c207a12/pages/en-ce-moment.vue")
  },
  {
    name: "plan-du-site",
    path: "/plan-du-site",
    component: () => import("/build/b2e7dd14-781e-413a-80e8-55257c207a12/pages/plan-du-site.vue")
  },
  {
    name: "profile-edit",
    path: "/profile/edit",
    meta: edit9NKXZJYEfZvSsFwJ3PyVdJoCBR72E3QaWD6djlnFoz4Meta || {},
    component: () => import("/build/b2e7dd14-781e-413a-80e8-55257c207a12/pages/profile/edit.vue")
  },
  {
    name: "stats-places",
    path: "/stats/places",
    meta: placesKo4VhraX1oYf56rYLGzbrhCHjbBJ9f6YDtcGcvw_45VNcMeta || {},
    component: () => import("/build/b2e7dd14-781e-413a-80e8-55257c207a12/pages/stats/places.vue")
  },
  {
    name: "accessibilite",
    path: "/accessibilite",
    component: () => import("/build/b2e7dd14-781e-413a-80e8-55257c207a12/pages/accessibilite.vue")
  },
  {
    name: "messages-id",
    path: "/messages/:id()",
    meta: _91id_93AZxLpLuwFbJiEVUQrRukI_dZr6Z05DFw1faWHWsaoWIMeta || {},
    component: () => import("/build/b2e7dd14-781e-413a-80e8-55257c207a12/pages/messages/[id].vue")
  },
  {
    name: "notifications",
    path: "/notifications",
    meta: notificationsiLLqncH_45HHd_4508tfEBaImF59aHff1Pe2Fxnxc4fMZfkMeta || {},
    component: () => import("/build/b2e7dd14-781e-413a-80e8-55257c207a12/pages/notifications.vue")
  },
  {
    name: "profile",
    path: "/profile",
    meta: indexiFdg4hu5g13N4BbhlRIlubIizzWX1qzwiuYOo4EyHd0Meta || {},
    component: () => import("/build/b2e7dd14-781e-413a-80e8-55257c207a12/pages/profile/index.vue")
  },
  {
    name: "support",
    path: "/support",
    meta: index1FHBYl5KyW_45XRVWozpAK9hfhA0FuMTF_45QSJ2a8Y2wkkMeta || {},
    component: () => import("/build/b2e7dd14-781e-413a-80e8-55257c207a12/pages/support/index.vue")
  },
  {
    name: "villes-slug",
    path: "/villes/:slug()",
    component: () => import("/build/b2e7dd14-781e-413a-80e8-55257c207a12/pages/villes/[slug].vue")
  },
  {
    name: "messages",
    path: "/messages",
    meta: indexyNhXG6Xre9SX8CJpUUN_y1LlyI2Jp9qe6xXJCJRx9MkMeta || {},
    component: () => import("/build/b2e7dd14-781e-413a-80e8-55257c207a12/pages/messages/index.vue")
  },
  {
    name: "quiz-generique",
    path: "/quiz/generique",
    meta: generiquewqm5tTqHiewpgytV_L5UGNtg87XQUZFMtlrd8N2qx_45UMeta || {},
    component: () => import("/build/b2e7dd14-781e-413a-80e8-55257c207a12/pages/quiz/generique.vue")
  },
  {
    name: "reseaux-slug",
    path: "/reseaux/:slug()",
    meta: _91slug_93r6cTenugJQdcebhj4e5unPYx0x_NnMj_45K_vn6RkelUAMeta || {},
    component: () => import("/build/b2e7dd14-781e-413a-80e8-55257c207a12/pages/reseaux/[slug].vue")
  },
  {
    name: "stats-missions",
    path: "/stats/missions",
    meta: missionsiZ0vpjaEhmHntEmKMqXU1f2idu9b6_zM2OlFq5Y2LrMMeta || {},
    component: () => import("/build/b2e7dd14-781e-413a-80e8-55257c207a12/pages/stats/missions.vue")
  },
  {
    name: "dashboard",
    path: "/dashboard",
    meta: indexBRRNDbJJ0Q41Y_zih18bJgmzZ3U39KdAl5yWp1fpe2wMeta || {},
    component: () => import("/build/b2e7dd14-781e-413a-80e8-55257c207a12/pages/dashboard/index.vue")
  },
  {
    name: "profile-favoris",
    path: "/profile/favoris",
    meta: favoriskDAM8mm2w3fVh_I6WTeDHPNHD07K1TyXJZ_45tlHwjgH0Meta || {},
    component: () => import("/build/b2e7dd14-781e-413a-80e8-55257c207a12/pages/profile/favoris.vue")
  },
  {
    name: "activites-slug",
    path: "/activites/:slug()",
    component: () => import("/build/b2e7dd14-781e-413a-80e8-55257c207a12/pages/activites/[slug].vue")
  },
  {
    name: "admin-other-logs",
    path: "/admin/other/logs",
    meta: logs65eJ_45OgHQTGpd_vV_NN5L5yl7WUAK9cvTmP7CIPMeVMMeta || {},
    component: () => import("/build/b2e7dd14-781e-413a-80e8-55257c207a12/pages/admin/other/logs.vue")
  },
  {
    name: "admin-ressources",
    path: "/admin/ressources",
    component: () => import("/build/b2e7dd14-781e-413a-80e8-55257c207a12/pages/admin/ressources.vue")
  },
  {
    name: "mentions-legales",
    path: "/mentions-legales",
    component: () => import("/build/b2e7dd14-781e-413a-80e8-55257c207a12/pages/mentions-legales.vue")
  },
  {
    name: "profile-missions",
    path: "/profile/missions",
    meta: missionsPqR9Dpv6dT4gg3BvEGPK5yK_45vcFVwtvgYwyMeWEiYXoMeta || {},
    component: () => import("/build/b2e7dd14-781e-413a-80e8-55257c207a12/pages/profile/missions.vue")
  },
  {
    name: "profile-settings",
    path: "/profile/settings",
    meta: settingsF07DjEts6qqQxrN2Z3vBnkBwxiJCHeCTGqg8U5HtJ_45kMeta || {},
    component: () => import("/build/b2e7dd14-781e-413a-80e8-55257c207a12/pages/profile/settings.vue")
  },
  {
    name: "admin-temoignages",
    path: "/admin/temoignages",
    component: () => import("/build/b2e7dd14-781e-413a-80e8-55257c207a12/pages/admin/temoignages.vue")
  },
  {
    name: "inscription",
    path: "/inscription",
    meta: index6RHNc1mGzShcHM6jtAragOmYQMRgkWc9_yBnUfQgMxgMeta || {},
    component: () => import("/build/b2e7dd14-781e-413a-80e8-55257c207a12/pages/inscription/index.vue")
  },
  {
    name: "maintenance-admin",
    path: "/maintenance/admin",
    meta: adminCom3hg5SH1nUJtNJq4SGd_45UfeOiMDqYI1Qr_45kTBWGIoMeta || {},
    component: () => import("/build/b2e7dd14-781e-413a-80e8-55257c207a12/pages/maintenance/admin.vue")
  },
  {
    name: "maintenance",
    path: "/maintenance",
    meta: index7wKvx5t634ZeRMykL5i_45eL7b1OYP_W9H0wQFxWPxyqgMeta || {},
    component: () => import("/build/b2e7dd14-781e-413a-80e8-55257c207a12/pages/maintenance/index.vue")
  },
  {
    name: "territoires",
    path: "/territoires",
    component: () => import("/build/b2e7dd14-781e-413a-80e8-55257c207a12/pages/territoires/index.vue")
  },
  {
    name: "invitations-hash",
    path: "/invitations/:hash()",
    meta: _91hash_93bRwNm98l1ZJYUrWI2VIV51fc7fdsHrrEUysZtT97awMMeta || {},
    component: () => import("/build/b2e7dd14-781e-413a-80e8-55257c207a12/pages/invitations/[hash].vue")
  },
  {
    name: "stats-utilisateurs",
    path: "/stats/utilisateurs",
    meta: utilisateursovuGWa6AEOPKKaQUBYpZmJ6XzOappUDNNDWeBHWz_45b4Meta || {},
    component: () => import("/build/b2e7dd14-781e-413a-80e8-55257c207a12/pages/stats/utilisateurs.vue")
  },
  {
    name: "associations-slug",
    path: "/associations/:slug()",
    component: () => import("/build/b2e7dd14-781e-413a-80e8-55257c207a12/pages/associations/[slug].vue")
  },
  {
    name: "departements-slug",
    path: "/departements/:slug()",
    component: () => import("/build/b2e7dd14-781e-413a-80e8-55257c207a12/pages/departements/[slug].vue")
  },
  {
    name: "organisations",
    path: "/organisations",
    component: () => import("/build/b2e7dd14-781e-413a-80e8-55257c207a12/pages/organisations/index.vue")
  },
  {
    name: "profile-preferences",
    path: "/profile/preferences",
    meta: preferencestlRY3v5yF_45JAHYwT_j1BlD0VLvRwf3yLxgZqiik8K_UMeta || {},
    component: () => import("/build/b2e7dd14-781e-413a-80e8-55257c207a12/pages/profile/preferences.vue")
  },
  {
    name: "stats-organisations",
    path: "/stats/organisations",
    meta: organisations95LcZqlSdndgMITWF3pNHxZVDIPwv3iSkGjInokN2ioMeta || {},
    component: () => import("/build/b2e7dd14-781e-413a-80e8-55257c207a12/pages/stats/organisations.vue")
  },
  {
    name: "temoignages-token",
    path: "/temoignages/:token()",
    meta: _91token_93lQWglrtvgP19br8AMpb8Qr_456hrzT0EFn_45oE2_H5aXB4Meta || {},
    component: () => import("/build/b2e7dd14-781e-413a-80e8-55257c207a12/pages/temoignages/[token].vue")
  },
  {
    name: "admin-contenus-posts",
    path: "/admin/contenus/posts",
    meta: postsB6AQCa_CoX_VKrdd_p_45K0g6oypiGJPEPyvFO8vUbGygMeta || {},
    component: () => import("/build/b2e7dd14-781e-413a-80e8-55257c207a12/pages/admin/contenus/posts.vue")
  },
  {
    name: "admin-missions",
    path: "/admin/missions",
    meta: indexB6hdaQA4D1A_dnwhbVytmBOqe5QbmWvjMka_45nSdR_45OEMeta || {},
    component: () => import("/build/b2e7dd14-781e-413a-80e8-55257c207a12/pages/admin/missions/index.vue")
  },
  {
    name: "messages-modeles-add",
    path: "/messages/modeles/add",
    meta: addzaitybMH7r3_EIEsZ_WzaJPBtumLIgAqdjnUcGbNvdsMeta || {},
    component: () => import("/build/b2e7dd14-781e-413a-80e8-55257c207a12/pages/messages/modeles/add.vue")
  },
  {
    name: "organisations-slug",
    path: "/organisations/:slug()",
    meta: _91slug_93pUT3rVXiOCvXsfbuSu6aWz2u9OOvbB5sOBE5MvPm_45IQMeta || {},
    component: () => import("/build/b2e7dd14-781e-413a-80e8-55257c207a12/pages/organisations/[slug].vue")
  },
  {
    name: "password-reset",
    path: "/password-reset",
    meta: indexC4SXzIylD74_o8oJ_458FN7ouXa_DpfaBZ0uMFa_45fU5_45wMeta || {},
    component: () => import("/build/b2e7dd14-781e-413a-80e8-55257c207a12/pages/password-reset/index.vue")
  },
  {
    name: "stats-participations",
    path: "/stats/participations",
    meta: participationsdqKR1Kw3FV2OJCRVEzXIgCLN7biDr5SlCu_EHa3R6UUMeta || {},
    component: () => import("/build/b2e7dd14-781e-413a-80e8-55257c207a12/pages/stats/participations.vue")
  },
  {
    name: "admin-settings-emails",
    path: "/admin/settings/emails",
    meta: emailsBcHrA7yzztTH3IiOI48tDvg2DcYcCQFT5VIpotSileIMeta || {},
    component: () => import("/build/b2e7dd14-781e-413a-80e8-55257c207a12/pages/admin/settings/emails.vue")
  },
  {
    name: "profile-alertes",
    path: "/profile/alertes",
    meta: indexF48mdBPxvjmyYR5PT9awNNSl1VSBOajkAh6RPKvqasEMeta || {},
    component: () => import("/build/b2e7dd14-781e-413a-80e8-55257c207a12/pages/profile/alertes/index.vue")
  },
  {
    name: "profile-notifications",
    path: "/profile/notifications",
    meta: notificationsbn4YBGkpdDCEAbv6Ge1c_VE9wrEw_h_45af_QONXxT_45HYMeta || {},
    component: () => import("/build/b2e7dd14-781e-413a-80e8-55257c207a12/pages/profile/notifications.vue")
  },
  {
    name: "admin-statistics",
    path: "/admin/statistics",
    meta: indexWATWXHt5_S9qcn8MPRV4b6a2rUmakmpA8YROsHp_45ATkMeta || {},
    component: () => import("/build/b2e7dd14-781e-413a-80e8-55257c207a12/pages/admin/statistics/index.vue")
  },
  {
    name: "charte-reserve-civique",
    path: "/charte-reserve-civique",
    component: () => import("/build/b2e7dd14-781e-413a-80e8-55257c207a12/pages/charte-reserve-civique.vue")
  },
  {
    name: "domaines-action-slug",
    path: "/domaines-action/:slug()",
    component: () => import("/build/b2e7dd14-781e-413a-80e8-55257c207a12/pages/domaines-action/[slug].vue")
  },
  {
    name: "messages-modeles",
    path: "/messages/modeles",
    meta: indexTxZC73jlp8tQ1WAmaQQz2onFiY2SpAWztTfRnYH6WkUMeta || {},
    component: () => import("/build/b2e7dd14-781e-413a-80e8-55257c207a12/pages/messages/modeles/index.vue")
  },
  {
    name: "password-reset-token",
    path: "/password-reset/:token()",
    meta: _91token_93XFePyPZWCVKNX9MX2T6Vp5qFjercz0JgJpc1XGPv4LwMeta || {},
    component: () => import("/build/b2e7dd14-781e-413a-80e8-55257c207a12/pages/password-reset/[token].vue")
  },
  {
    name: "quiz-decembre-ensemble",
    path: "/quiz/decembre-ensemble",
    meta: decembre_45ensembletEll_5bvJLnXepWNcAH_45nACdZd8meIdfcEmfUhbdNnQMeta || {},
    component: () => import("/build/b2e7dd14-781e-413a-80e8-55257c207a12/pages/quiz/decembre-ensemble.vue")
  },
  {
    name: "admin-other-invitations",
    path: "/admin/other/invitations",
    meta: invitationshb_K3W7g9POPBRA_9WHetj0Nhvic3knXKC7_4528mMdRkMeta || {},
    component: () => import("/build/b2e7dd14-781e-413a-80e8-55257c207a12/pages/admin/other/invitations.vue")
  },
  {
    name: "admin-settings-messages",
    path: "/admin/settings/messages",
    meta: messagesVONfNjTcqqN8Ed6fHjY6IRUIdHIGlDIgsx3brSs2M1MMeta || {},
    component: () => import("/build/b2e7dd14-781e-413a-80e8-55257c207a12/pages/admin/settings/messages.vue")
  },
  {
    name: "admin-statistics-places",
    path: "/admin/statistics/places",
    meta: placesPLRWbl9d6W_EhiGXuZCVe8ppo2LrFneI7gquKSmsH5MMeta || {},
    component: () => import("/build/b2e7dd14-781e-413a-80e8-55257c207a12/pages/admin/statistics/places.vue")
  },
  {
    name: "admin-settings-rules-add",
    path: "/admin/settings/rules/add",
    meta: addONlmDfsSQ_hqwNUUi2dZfqNNvbuc912xo2rkLqxty7QMeta || {},
    component: () => import("/build/b2e7dd14-781e-413a-80e8-55257c207a12/pages/admin/settings/rules/add.vue")
  },
  {
    name: "admin-utilisateurs",
    path: "/admin/utilisateurs",
    meta: indexG1Bz5yxexgB325aFGmwI8TyJaXuRLgWIWylLxkjq27sMeta || {},
    component: () => import("/build/b2e7dd14-781e-413a-80e8-55257c207a12/pages/admin/utilisateurs/index.vue")
  },
  {
    name: "missions-benevolat",
    path: "/missions-benevolat",
    meta: index30IPpk_IXKVPqfV9nHzvRgDl8WrYmfXfi6dDzxzpUjYMeta || {},
    component: () => import("/build/b2e7dd14-781e-413a-80e8-55257c207a12/pages/missions-benevolat/index.vue")
  },
  {
    name: "admin-missions-id-dates",
    path: "/admin/missions/:id()/dates",
    meta: datessn8RE2jaYTYYhP6o2qv188BvtxQ5IniYGZIxVr_5LtIMeta || {},
    component: () => import("/build/b2e7dd14-781e-413a-80e8-55257c207a12/pages/admin/missions/[id]/dates.vue")
  },
  {
    name: "admin-missions-id",
    path: "/admin/missions/:id()",
    meta: indexhLpSiLKzVzd22tLUtE_45XDrm5sKtc0iyWxXdSaTqP4IcMeta || {},
    component: () => import("/build/b2e7dd14-781e-413a-80e8-55257c207a12/pages/admin/missions/[id]/index.vue")
  },
  {
    name: "admin-missions-id-lieux",
    path: "/admin/missions/:id()/lieux",
    meta: lieuxAAax56JiHAz0vpRIpu_45iv32AcAARpG0s9Om5DezrYVoMeta || {},
    component: () => import("/build/b2e7dd14-781e-413a-80e8-55257c207a12/pages/admin/missions/[id]/lieux.vue")
  },
  {
    name: "admin-missions-id-title",
    path: "/admin/missions/:id()/title",
    meta: titleBcuJF1q_89uALNrmewJdHGy3p6dpKPp575olNcvJENsMeta || {},
    component: () => import("/build/b2e7dd14-781e-413a-80e8-55257c207a12/pages/admin/missions/[id]/title.vue")
  },
  {
    name: "admin-organisations",
    path: "/admin/organisations",
    meta: indexIVuvx66N8r_PcfnsJOjPl6QsPTHwbaXgqCyXCya61uoMeta || {},
    component: () => import("/build/b2e7dd14-781e-413a-80e8-55257c207a12/pages/admin/organisations/index.vue")
  },
  {
    name: "admin-statistics-missions",
    path: "/admin/statistics/missions",
    meta: missionsbPOrakYL_45kqHc_45NsciHKIsFJOEyg1INVoYn0v_45J_45QJIMeta || {},
    component: () => import("/build/b2e7dd14-781e-413a-80e8-55257c207a12/pages/admin/statistics/missions.vue")
  },
  {
    name: "admin-contenus-reseaux-add",
    path: "/admin/contenus/reseaux/add",
    meta: adds_456OYsaNv9yGTqgZsj_UrNK8y4oXLgEeui4bPy2jl_wMeta || {},
    component: () => import("/build/b2e7dd14-781e-413a-80e8-55257c207a12/pages/admin/contenus/reseaux/add.vue")
  },
  {
    name: "admin-missions-id-visuel",
    path: "/admin/missions/:id()/visuel",
    meta: visueldctYqH32RaF5SGO9JXAMPNovLLwaeCxc64jI8KHSzMEMeta || {},
    component: () => import("/build/b2e7dd14-781e-413a-80e8-55257c207a12/pages/admin/missions/[id]/visuel.vue")
  },
  {
    name: "admin-participations",
    path: "/admin/participations",
    meta: indexqLX1Cb766fz2FwNDzMkvT6S_cQhislTFORO_45MkiaoCcMeta || {},
    component: () => import("/build/b2e7dd14-781e-413a-80e8-55257c207a12/pages/admin/participations/index.vue")
  },
  {
    name: "admin-settings-rules",
    path: "/admin/settings/rules",
    meta: indexatuBGjmjgAu2u7QiWavE0HxJjBt_yEH1evlfsB_45Q00oMeta || {},
    component: () => import("/build/b2e7dd14-781e-413a-80e8-55257c207a12/pages/admin/settings/rules/index.vue")
  },
  {
    name: "inscription-benevole",
    path: "/inscription/benevole",
    meta: indexgI3l2Ikhdi_B_XW7FJDYj0acAu1j6Uuxio8lXc3amJsMeta || {},
    component: () => import("/build/b2e7dd14-781e-413a-80e8-55257c207a12/pages/inscription/benevole/index.vue")
  },
  {
    name: "admin-contenus-domaines-add",
    path: "/admin/contenus/domaines/add",
    meta: addaKnIgpTl2LXQYBjHI_45ZmYakdqfzrObkThlA_f_TcXd0Meta || {},
    component: () => import("/build/b2e7dd14-781e-413a-80e8-55257c207a12/pages/admin/contenus/domaines/add.vue")
  },
  {
    name: "admin-taxonomies-slug-add",
    path: "/admin/taxonomies/:slug()/add",
    meta: addvNasyxhdHP_45fsoAx5WELIAXAExTxwEB8d6FnQstxgUkMeta || {},
    component: () => import("/build/b2e7dd14-781e-413a-80e8-55257c207a12/pages/admin/taxonomies/[slug]/add.vue")
  },
  {
    name: "admin-contenus-activites-add",
    path: "/admin/contenus/activites/add",
    meta: addsKvY9Q8DGu9yHvlS24Gbfjt9hlge_Rpw_WUyT6JkfiQMeta || {},
    component: () => import("/build/b2e7dd14-781e-413a-80e8-55257c207a12/pages/admin/contenus/activites/add.vue")
  },
  {
    name: "admin-contenus-reseaux",
    path: "/admin/contenus/reseaux",
    meta: indexH0GurariLtoMyw8m34iMIODnbhPS_45LrnMa0dqFetZeEMeta || {},
    component: () => import("/build/b2e7dd14-781e-413a-80e8-55257c207a12/pages/admin/contenus/reseaux/index.vue")
  },
  {
    name: "admin-statistics-conversions",
    path: "/admin/statistics/conversions",
    meta: conversions3javaxQNab8YArdsVp83sWUCMJuIJZJ17CRGBdMCpgsMeta || {},
    component: () => import("/build/b2e7dd14-781e-413a-80e8-55257c207a12/pages/admin/statistics/conversions.vue")
  },
  {
    name: "admin-utilisateurs-id-edit",
    path: "/admin/utilisateurs/:id()/edit",
    meta: edit9_45zSUWotN0h3ZyHJc3829az9dyCrMfIpka1dQRDykWIMeta || {},
    component: () => import("/build/b2e7dd14-781e-413a-80e8-55257c207a12/pages/admin/utilisateurs/[id]/edit.vue")
  },
  {
    name: "politique-de-confidentialite",
    path: "/politique-de-confidentialite",
    component: () => import("/build/b2e7dd14-781e-413a-80e8-55257c207a12/pages/politique-de-confidentialite.vue")
  },
  {
    name: "admin-contenus-domaines",
    path: "/admin/contenus/domaines",
    meta: indextIdvnt3xxKUkA8ZmNemsiUtNOeOynUHdKhgHWocUz7wMeta || {},
    component: () => import("/build/b2e7dd14-781e-413a-80e8-55257c207a12/pages/admin/contenus/domaines/index.vue")
  },
  {
    name: "admin-contenus-ressources-add",
    path: "/admin/contenus/ressources/add",
    meta: addRtgk4gSxgBn5Z1T0SQ_45rElLlyf2fJveeFFMwVThSjDAMeta || {},
    component: () => import("/build/b2e7dd14-781e-413a-80e8-55257c207a12/pages/admin/contenus/ressources/add.vue")
  },
  {
    name: "admin-missions-id-benevoles",
    path: "/admin/missions/:id()/benevoles",
    meta: benevoles6hx2MIjDeDt_45FPgqH56i_45F0Ctz0z43itNgexU7EM8pcMeta || {},
    component: () => import("/build/b2e7dd14-781e-413a-80e8-55257c207a12/pages/admin/missions/[id]/benevoles.vue")
  },
  {
    name: "admin-organisations-id-edit",
    path: "/admin/organisations/:id()/edit",
    meta: editooAm601KgjJ3oJRlBmE4cRfB3amHcJG_RHCB_jJVuMQMeta || {},
    component: () => import("/build/b2e7dd14-781e-413a-80e8-55257c207a12/pages/admin/organisations/[id]/edit.vue")
  },
  {
    name: "admin-statistics-utilisateurs",
    path: "/admin/statistics/utilisateurs",
    meta: utilisateursL8bqoqLvz6oSFE7hO1MQtSDadPwJwoYX3_450__bPpFcMMeta || {},
    component: () => import("/build/b2e7dd14-781e-413a-80e8-55257c207a12/pages/admin/statistics/utilisateurs.vue")
  },
  {
    name: "admin-taxonomies-slug",
    path: "/admin/taxonomies/:slug()",
    meta: indexuHSPn649NC3T2WnCoA4dAljYZYHws_PrQdxERFQigmgMeta || {},
    component: () => import("/build/b2e7dd14-781e-413a-80e8-55257c207a12/pages/admin/taxonomies/[slug]/index.vue")
  },
  {
    name: "admin-utilisateurs-id",
    path: "/admin/utilisateurs/:id()",
    meta: indexP8_3RrAejkitEtellE0vtK_nT3S65JqYVkaWksjkgfsMeta || {},
    component: () => import("/build/b2e7dd14-781e-413a-80e8-55257c207a12/pages/admin/utilisateurs/[id]/index.vue")
  },
  {
    name: "inscription-responsable",
    path: "/inscription/responsable",
    component: () => import("/build/b2e7dd14-781e-413a-80e8-55257c207a12/pages/inscription/responsable/index.vue")
  },
  {
    name: "missions-benevolat-id",
    path: "/missions-benevolat/:id()",
    component: () => import("/build/b2e7dd14-781e-413a-80e8-55257c207a12/pages/missions-benevolat/[id]/index.vue")
  },
  {
    name: "quiz-septembre-pour-apprendre",
    path: "/quiz/septembre-pour-apprendre",
    meta: septembre_45pour_45apprendreRyyX9zLxqbe8FmvCuDBpvrDn2Fp_JGWXSn26WsDvnpkMeta || {},
    component: () => import("/build/b2e7dd14-781e-413a-80e8-55257c207a12/pages/quiz/septembre-pour-apprendre.vue")
  },
  {
    name: "admin-contenus-activites",
    path: "/admin/contenus/activites",
    meta: indexmQMT30uneSPfK02tJxFN_YKsoO9nmpZWA2D_S8XiCNoMeta || {},
    component: () => import("/build/b2e7dd14-781e-413a-80e8-55257c207a12/pages/admin/contenus/activites/index.vue")
  },
  {
    name: "admin-contenus-territoires-add",
    path: "/admin/contenus/territoires/add",
    meta: addcCAL7Y4ZVgCGSceXmo0OAbOcPz9Dmt_457PEOUubz8gWcMeta || {},
    component: () => import("/build/b2e7dd14-781e-413a-80e8-55257c207a12/pages/admin/contenus/territoires/add.vue")
  },
  {
    name: "admin-organisations-id",
    path: "/admin/organisations/:id()",
    meta: indexW2Zk0JuTfU2s752qG7gNukqL70jY17ltFazlODAntOIMeta || {},
    component: () => import("/build/b2e7dd14-781e-413a-80e8-55257c207a12/pages/admin/organisations/[id]/index.vue")
  },
  {
    name: "admin-settings-rules-id-edit",
    path: "/admin/settings/rules/:id()/edit",
    meta: editTllQgONizvADaJNrpnBF6uQGfGquCOM8tjdGpOgd9Q0Meta || {},
    component: () => import("/build/b2e7dd14-781e-413a-80e8-55257c207a12/pages/admin/settings/rules/[id]/edit.vue")
  },
  {
    name: "missions-benevolat-id-slug",
    path: "/missions-benevolat/:id()/:slug()",
    component: () => import("/build/b2e7dd14-781e-413a-80e8-55257c207a12/pages/missions-benevolat/[id]/[slug].vue")
  },
  {
    name: "quiz-printemps-pour-la-planete",
    path: "/quiz/printemps-pour-la-planete",
    meta: printemps_45pour_45la_45planetetF8MvxIqWsqSST5PA8DJGjKWkrRe5_45SVGrcRD0SYU44Meta || {},
    component: () => import("/build/b2e7dd14-781e-413a-80e8-55257c207a12/pages/quiz/printemps-pour-la-planete.vue")
  },
  {
    name: "admin-contenus-ressources",
    path: "/admin/contenus/ressources",
    meta: indexp_j9kiQXtwy389_qvW5baQTiN_451SKXarYxxmIyPvM7oMeta || {},
    component: () => import("/build/b2e7dd14-781e-413a-80e8-55257c207a12/pages/admin/contenus/ressources/index.vue")
  },
  {
    name: "admin-statistics-participations",
    path: "/admin/statistics/participations",
    meta: participationsOpDZfhuQy4MEJ9cT_45IehTK1zx_DvdUx_45ALuKxwAXtPgMeta || {},
    component: () => import("/build/b2e7dd14-781e-413a-80e8-55257c207a12/pages/admin/statistics/participations.vue")
  },
  {
    name: "charte-bon-fonctionnement",
    path: "/charte-bon-fonctionnement",
    component: () => import("/build/b2e7dd14-781e-413a-80e8-55257c207a12/pages/charte-bon-fonctionnement/index.vue")
  },
  {
    name: "support-referents-activity-logs",
    path: "/support/referents/activity-logs",
    meta: activity_45logsW9SFviD7wKelCqZJ5VMvTc1RABMfQBVhu2Yfo6ARyDMMeta || {},
    component: () => import("/build/b2e7dd14-781e-413a-80e8-55257c207a12/pages/support/referents/activity-logs.vue")
  },
  {
    name: "admin-contenus-reseaux-id-edit",
    path: "/admin/contenus/reseaux/:id()/edit",
    meta: editSs_JcTwgqSb8zusziOWkd90iVHNHcm2iRCkOKUsIsEQMeta || {},
    component: () => import("/build/b2e7dd14-781e-413a-80e8-55257c207a12/pages/admin/contenus/reseaux/[id]/edit.vue")
  },
  {
    name: "admin-contenus-territoires",
    path: "/admin/contenus/territoires",
    meta: indexQoKD68tXPTIKstJkKRpYxkjoMCLd_AiDGgP5SZEBAtwMeta || {},
    component: () => import("/build/b2e7dd14-781e-413a-80e8-55257c207a12/pages/admin/contenus/territoires/index.vue")
  },
  {
    name: "admin-missions-id-informations",
    path: "/admin/missions/:id()/informations",
    meta: informationsAe6yk9cMaht1nEbs0F_6qbrbFGkZk4gXIuqYQcvNr70Meta || {},
    component: () => import("/build/b2e7dd14-781e-413a-80e8-55257c207a12/pages/admin/missions/[id]/informations.vue")
  },
  {
    name: "admin-missions-id-responsables",
    path: "/admin/missions/:id()/responsables",
    meta: responsablesa9oIFnfmsRc2bkCoKl6jy_pTrfEXi8jRjVTDr67C87wMeta || {},
    component: () => import("/build/b2e7dd14-781e-413a-80e8-55257c207a12/pages/admin/missions/[id]/responsables.vue")
  },
  {
    name: "admin-contenus-domaines-id-edit",
    path: "/admin/contenus/domaines/:id()/edit",
    meta: edit6xRMdID7kBHcIeJTjuNRXCx_45ijkWbhBy_I8FT1CE5lgMeta || {},
    component: () => import("/build/b2e7dd14-781e-413a-80e8-55257c207a12/pages/admin/contenus/domaines/[id]/edit.vue")
  },
  {
    name: "admin-contenus-reseaux-id",
    path: "/admin/contenus/reseaux/:id()",
    meta: indexWoY39jeXcO1P5OylGJcp_4563nayPdySJVTDQdsyRQaTUMeta || {},
    component: () => import("/build/b2e7dd14-781e-413a-80e8-55257c207a12/pages/admin/contenus/reseaux/[id]/index.vue")
  },
  {
    name: "admin-contenus-testimonials",
    path: "/admin/contenus/testimonials",
    meta: index2plzhDquWlvk8uAxGlKi_TKLZl9B2y4ORfzxG4aawEcMeta || {},
    component: () => import("/build/b2e7dd14-781e-413a-80e8-55257c207a12/pages/admin/contenus/testimonials/index.vue")
  },
  {
    name: "admin-statistics-indicateurs-cles",
    path: "/admin/statistics/indicateurs-cles",
    meta: indicateurs_45cles7D_45oZDAZg6A4kYNfT0SzR2vOY1YaFeTuiZijnthMZlUMeta || {},
    component: () => import("/build/b2e7dd14-781e-413a-80e8-55257c207a12/pages/admin/statistics/indicateurs-cles.vue")
  },
  {
    name: "admin-taxonomies-slug-id-edit",
    path: "/admin/taxonomies/:slug()/:id()/edit",
    meta: edit_O_pSIexwcsuPdFAUn7_454yK3VzsHghgBh8omJLG0sZgMeta || {},
    component: () => import("/build/b2e7dd14-781e-413a-80e8-55257c207a12/pages/admin/taxonomies/[slug]/[id]/edit.vue")
  },
  {
    name: "inscription-benevole-step-profile",
    path: "/inscription/benevole/step/profile",
    meta: profilen_HZlgbD51JLLcq7zRRAVCseOLCcTYTIVQF0beoY7ZAMeta || {},
    component: () => import("/build/b2e7dd14-781e-413a-80e8-55257c207a12/pages/inscription/benevole/step/profile.vue")
  },
  {
    name: "profile-charte-bon-fonctionnement",
    path: "/profile/charte-bon-fonctionnement",
    component: () => import("/build/b2e7dd14-781e-413a-80e8-55257c207a12/pages/profile/charte-bon-fonctionnement.vue")
  },
  {
    name: "support-referents-waiting-actions",
    path: "/support/referents/waiting-actions",
    meta: waiting_45actionsiRcHuRX1xYjTCqOA8zNHcJ7B8XbCPJUUP90Op1RhnDwMeta || {},
    component: () => import("/build/b2e7dd14-781e-413a-80e8-55257c207a12/pages/support/referents/waiting-actions.vue")
  },
  {
    name: "admin-contenus-activites-id-edit",
    path: "/admin/contenus/activites/:id()/edit",
    meta: edit0kBcqsREAE0Zxsij9M18hVWoLcMnJ4CLnsjoTciSQZgMeta || {},
    component: () => import("/build/b2e7dd14-781e-413a-80e8-55257c207a12/pages/admin/contenus/activites/[id]/edit.vue")
  },
  {
    name: "admin-contenus-modeles-mission-add",
    path: "/admin/contenus/modeles-mission/add",
    meta: addDksily7wM4VRj1Y7P6pBRPXuqWey2QVMdD7OuJdiNkwMeta || {},
    component: () => import("/build/b2e7dd14-781e-413a-80e8-55257c207a12/pages/admin/contenus/modeles-mission/add.vue")
  },
  {
    name: "conditions-generales-d-utilisation",
    path: "/conditions-generales-d-utilisation",
    component: () => import("/build/b2e7dd14-781e-413a-80e8-55257c207a12/pages/conditions-generales-d-utilisation.vue")
  },
  {
    name: "admin-contenus-activites-id",
    path: "/admin/contenus/activites/:id()",
    meta: indexGgrmtGVgSouywwLxGKpPZ8_45xmuuQTenBeLkzdlih2T8Meta || {},
    component: () => import("/build/b2e7dd14-781e-413a-80e8-55257c207a12/pages/admin/contenus/activites/[id]/index.vue")
  },
  {
    name: "admin-contenus-ressources-id-edit",
    path: "/admin/contenus/ressources/:id()/edit",
    meta: edit41o5WIlJ35FaWrE5jAlQt2MXdVZEEJG7yRE_458Bi3MBsMeta || {},
    component: () => import("/build/b2e7dd14-781e-413a-80e8-55257c207a12/pages/admin/contenus/ressources/[id]/edit.vue")
  },
  {
    name: "admin-organisations-id-diffusions",
    path: "/admin/organisations/:id()/diffusions",
    meta: diffusionsYJplRwaUp41PI5kWheGZlpd6omzIod6IglbNaekMJYwMeta || {},
    component: () => import("/build/b2e7dd14-781e-413a-80e8-55257c207a12/pages/admin/organisations/[id]/diffusions.vue")
  },
  {
    name: "admin-statistics-suivis-moderations",
    path: "/admin/statistics/suivis/moderations",
    meta: moderationsubpWFfPAqc2_45fH3bPTs2froFgxxIJiGdsLgPH1NFaEQMeta || {},
    component: () => import("/build/b2e7dd14-781e-413a-80e8-55257c207a12/pages/admin/statistics/suivis/moderations.vue")
  },
  {
    name: "charte-bon-fonctionnement-benevoles",
    path: "/charte-bon-fonctionnement/benevoles",
    component: () => import("/build/b2e7dd14-781e-413a-80e8-55257c207a12/pages/charte-bon-fonctionnement/benevoles.vue")
  },
  {
    name: "support-actions-google-api-indexing",
    path: "/support/actions/google-api-indexing",
    meta: google_45api_45indexingftBbKMLPOgcLHu2eGPFPe3bNhBEJW9TsAi65WjVli_45AMeta || {},
    component: () => import("/build/b2e7dd14-781e-413a-80e8-55257c207a12/pages/support/actions/google-api-indexing.vue")
  },
  {
    name: "admin-contenus-modeles-mission",
    path: "/admin/contenus/modeles-mission",
    meta: indexj_45Ssr3O3RhGmb6agd6ZVRatDVHTVl68HKlfVfyq_45YhgMeta || {},
    component: () => import("/build/b2e7dd14-781e-413a-80e8-55257c207a12/pages/admin/contenus/modeles-mission/index.vue")
  },
  {
    name: "admin-contenus-territoires-id-edit",
    path: "/admin/contenus/territoires/:id()/edit",
    meta: edit7xIB_Sh9Nud_45ssTkXof8NnMkizNsBYwhvLGw30CVRT8Meta || {},
    component: () => import("/build/b2e7dd14-781e-413a-80e8-55257c207a12/pages/admin/contenus/territoires/[id]/edit.vue")
  },
  {
    name: "admin-statistics-organisations",
    path: "/admin/statistics/organisations",
    meta: indexI4k_45ontIQGr2S2sHeZI_UtTpKTFfxKxa213xk14iRF4Meta || {},
    component: () => import("/build/b2e7dd14-781e-413a-80e8-55257c207a12/pages/admin/statistics/organisations/index.vue")
  },
  {
    name: "inscription-responsable-step-profile",
    path: "/inscription/responsable/step/profile",
    meta: profile_45ZTFPyOuePS_45VXsLVipDNmBMiQVCL9lwBMZiW4HT6zgMeta || {},
    component: () => import("/build/b2e7dd14-781e-413a-80e8-55257c207a12/pages/inscription/responsable/step/profile.vue")
  },
  {
    name: "admin-contenus-territoires-id",
    path: "/admin/contenus/territoires/:id()",
    meta: indexzw9S6_45oBRpl8Tg85BWxSVLuJFxsvCNGnkTLhpI3Gd8oMeta || {},
    component: () => import("/build/b2e7dd14-781e-413a-80e8-55257c207a12/pages/admin/contenus/territoires/[id]/index.vue")
  },
  {
    name: "admin-contenus-testimonials-id-edit",
    path: "/admin/contenus/testimonials/:id()/edit",
    meta: editlmvoWqesFGB_bCKUPSsPnNPavH3tL_sEJs7gy_Ji_EEMeta || {},
    component: () => import("/build/b2e7dd14-781e-413a-80e8-55257c207a12/pages/admin/contenus/testimonials/[id]/edit.vue")
  },
  {
    name: "admin-organisations-id-missions-add",
    path: "/admin/organisations/:id()/missions/add",
    meta: addd4PANeJc5CWwZQIGO6ghOJIT3bX9eJ_B9aPa5PnyNVQMeta || {},
    component: () => import("/build/b2e7dd14-781e-413a-80e8-55257c207a12/pages/admin/organisations/[id]/missions/add.vue")
  },
  {
    name: "inscription-benevole-step-competences",
    path: "/inscription/benevole/step/competences",
    meta: competencestc2X_454xmTlybYIihoZDZeo0RMe8DWPZsYNk_45_45d1OxfoMeta || {},
    component: () => import("/build/b2e7dd14-781e-413a-80e8-55257c207a12/pages/inscription/benevole/step/competences.vue")
  },
  {
    name: "inscription-benevole-step-preferences",
    path: "/inscription/benevole/step/preferences",
    meta: preferencesq9udvL5R9V3mqIp4maQ_45jzTGEaxtRLIDYcWt1mpRrWIMeta || {},
    component: () => import("/build/b2e7dd14-781e-413a-80e8-55257c207a12/pages/inscription/benevole/step/preferences.vue")
  },
  {
    name: "support-actions-search-archived-users",
    path: "/support/actions/search-archived-users",
    meta: search_45archived_45usersEv2o3p0d7_45bpjzmCgLMLT3fbq6gyN2XSAlPjQUIokOgMeta || {},
    component: () => import("/build/b2e7dd14-781e-413a-80e8-55257c207a12/pages/support/actions/search-archived-users.vue")
  },
  {
    name: "support-contents-doublons-territoires",
    path: "/support/contents/doublons-territoires",
    meta: doublons_45territoiresXzejZz1JjBWaGC5o_aUagEtXzaIuutCuDqTcxAXxNYcMeta || {},
    component: () => import("/build/b2e7dd14-781e-413a-80e8-55257c207a12/pages/support/contents/doublons-territoires.vue")
  },
  {
    name: "charte-bon-fonctionnement-responsables",
    path: "/charte-bon-fonctionnement/responsables",
    component: () => import("/build/b2e7dd14-781e-413a-80e8-55257c207a12/pages/charte-bon-fonctionnement/responsables.vue")
  },
  {
    name: "support-actions-transfert-organisation",
    path: "/support/actions/transfert-organisation",
    meta: transfert_45organisationoMOPfl2vUeZzx223PqciI3HTZKqOt2_45Csr_45eNBv_45k9kMeta || {},
    component: () => import("/build/b2e7dd14-781e-413a-80e8-55257c207a12/pages/support/actions/transfert-organisation.vue")
  },
  {
    name: "support-responsables-missions-outdated",
    path: "/support/responsables/missions-outdated",
    meta: missions_45outdatedeUH4LuP51G6HvXZZ5D86mfhREoZdCInjypWs_mCFS_45kMeta || {},
    component: () => import("/build/b2e7dd14-781e-413a-80e8-55257c207a12/pages/support/responsables/missions-outdated.vue")
  },
  {
    name: "admin-settings-rules-id-pending-items",
    path: "/admin/settings/rules/:id()/pending-items",
    meta: pending_45itemsYjCotMM_r5SywTphfl9KHgFzBESFDSK1oEVZHdNVEGgMeta || {},
    component: () => import("/build/b2e7dd14-781e-413a-80e8-55257c207a12/pages/admin/settings/rules/[id]/pending-items.vue")
  },
  {
    name: "support-actions-user-reset-context-role",
    path: "/support/actions/user-reset-context-role",
    meta: user_45reset_45context_45rolejP5j_45J9yI8a6GXCywgDRx8d3Z6UBBffdahwpupFO16UMeta || {},
    component: () => import("/build/b2e7dd14-781e-413a-80e8-55257c207a12/pages/support/actions/user-reset-context-role.vue")
  },
  {
    name: "support-contents-doublons-organisations",
    path: "/support/contents/doublons-organisations",
    meta: doublons_45organisationsf8dKlKUYGYts4zHhgPAavPim_45d6zrIQfBCozauxttywMeta || {},
    component: () => import("/build/b2e7dd14-781e-413a-80e8-55257c207a12/pages/support/contents/doublons-organisations.vue")
  },
  {
    name: "admin-contenus-modeles-mission-id-edit",
    path: "/admin/contenus/modeles-mission/:id()/edit",
    meta: editemF9vpSvLJZrkJ_EmxGctrsIuGavKSJwiDHHk8iGlVMMeta || {},
    component: () => import("/build/b2e7dd14-781e-413a-80e8-55257c207a12/pages/admin/contenus/modeles-mission/[id]/edit.vue")
  },
  {
    name: "inscription-benevole-step-disponibilites",
    path: "/inscription/benevole/step/disponibilites",
    meta: disponibilitesjchVzjESCJjgigccuMrIjCpLm0ZuTjMACaqJ_5EJqpMMeta || {},
    component: () => import("/build/b2e7dd14-781e-413a-80e8-55257c207a12/pages/inscription/benevole/step/disponibilites.vue")
  },
  {
    name: "support-actions-user-reset-password-link",
    path: "/support/actions/user-reset-password-link",
    meta: user_45reset_45password_45linkLvOWCF2UjD8psCENThvBk_45vwMgJviIny3mOSYOSuxccMeta || {},
    component: () => import("/build/b2e7dd14-781e-413a-80e8-55257c207a12/pages/support/actions/user-reset-password-link.vue")
  },
  {
    name: "admin-contenus-modeles-mission-id",
    path: "/admin/contenus/modeles-mission/:id()",
    meta: indexFda8OTUQgGOEAQUd1_5qYNl68dBzvlo3uFv_DPGPxIEMeta || {},
    component: () => import("/build/b2e7dd14-781e-413a-80e8-55257c207a12/pages/admin/contenus/modeles-mission/[id]/index.vue")
  },
  {
    name: "inscription-responsable-step-collectivite",
    path: "/inscription/responsable/step/collectivite",
    meta: collectiviteGfphakMYbJZHsorFCGIPtjPQrgPWscBplTR9fzEgi0wMeta || {},
    component: () => import("/build/b2e7dd14-781e-413a-80e8-55257c207a12/pages/inscription/responsable/step/collectivite.vue")
  },
  {
    name: "inscription-responsable-step-organisation",
    path: "/inscription/responsable/step/organisation",
    meta: organisation7PViXDCOaoCsclqZaRR2xTsGJkjPTI6tNVwfmhiCKH4Meta || {},
    component: () => import("/build/b2e7dd14-781e-413a-80e8-55257c207a12/pages/inscription/responsable/step/organisation.vue")
  },
  {
    name: "admin-missions-id-benevoles-informations",
    path: "/admin/missions/:id()/benevoles-informations",
    meta: benevoles_45informationsZ0QZ9V2kHDg7BRNFCWJ7_450cV4NX6bXiq0QSFH1zB6P4Meta || {},
    component: () => import("/build/b2e7dd14-781e-413a-80e8-55257c207a12/pages/admin/missions/[id]/benevoles-informations.vue")
  },
  {
    name: "admin-statistics-api-engagement-trafic-entrant",
    path: "/admin/statistics/api-engagement/trafic-entrant",
    meta: trafic_45entrantwVPGCiIWY_F2ZpqDpSkQ_HYlQ6FejyLdn_60VPMdwXIMeta || {},
    component: () => import("/build/b2e7dd14-781e-413a-80e8-55257c207a12/pages/admin/statistics/api-engagement/trafic-entrant.vue")
  },
  {
    name: "admin-statistics-api-engagement-trafic-sortant",
    path: "/admin/statistics/api-engagement/trafic-sortant",
    meta: trafic_45sortantqCrT8JR9VkLLqGIzY69H5q_45xP9Axi53CyNiWzYVkYpgMeta || {},
    component: () => import("/build/b2e7dd14-781e-413a-80e8-55257c207a12/pages/admin/statistics/api-engagement/trafic-sortant.vue")
  },
  {
    name: "admin-missions-id-trouver-des-benevoles",
    path: "/admin/missions/:id()/trouver-des-benevoles",
    meta: indexoc_45ZFCaVckU72ti8P1Irob4LpfFtKaPFgaMs35s_45OHkMeta || {},
    component: () => import("/build/b2e7dd14-781e-413a-80e8-55257c207a12/pages/admin/missions/[id]/trouver-des-benevoles/index.vue")
  },
  {
    name: "admin-statistics-departements-missions-perimees",
    path: "/admin/statistics/departements/missions-perimees",
    meta: missions_45perimeescITXl8VhN7UqENqUM3bMLkUhGyIzTiH8XAjfWNFF6vUMeta || {},
    component: () => import("/build/b2e7dd14-781e-413a-80e8-55257c207a12/pages/admin/statistics/departements/missions-perimees.vue")
  },
  {
    name: "admin-statistics-departements-missions-a-valider",
    path: "/admin/statistics/departements/missions-a-valider",
    meta: missions_45a_45validerrjLC0EbrMXqqH3eduzE0GpS4axLDD4OWczWDnUkMWb4Meta || {},
    component: () => import("/build/b2e7dd14-781e-413a-80e8-55257c207a12/pages/admin/statistics/departements/missions-a-valider.vue")
  },
  {
    name: "admin-statistics-organisations-missions-perimees",
    path: "/admin/statistics/organisations/missions-perimees",
    meta: missions_45perimeesRjcECZoi3wDihN7LIG4_YmCauuBTs9GKMww7nrXoieAMeta || {},
    component: () => import("/build/b2e7dd14-781e-413a-80e8-55257c207a12/pages/admin/statistics/organisations/missions-perimees.vue")
  },
  {
    name: "inscription-responsable-step-organisation-images",
    path: "/inscription/responsable/step/organisation-images",
    meta: organisation_45imageswJ41C9iaLwVPp6uaZPFGuiqWRlH53oETSi3dHtO1AG0Meta || {},
    component: () => import("/build/b2e7dd14-781e-413a-80e8-55257c207a12/pages/inscription/responsable/step/organisation-images.vue")
  },
  {
    name: "inscription-responsable-step-organisation-details",
    path: "/inscription/responsable/step/organisation-details",
    meta: organisation_45detailsRZVCVmfHuxuFCXZLhwt0FZMa6_454_45tUUiPQnB35JIcpoMeta || {},
    component: () => import("/build/b2e7dd14-781e-413a-80e8-55257c207a12/pages/inscription/responsable/step/organisation-details.vue")
  },
  {
    name: "support-responsables-participations-to-be-treated",
    path: "/support/responsables/participations-to-be-treated",
    meta: participations_45to_45be_45treatedy7X_iX7wf4gnNmfaGcQhx7AK_Ev3vveq571zQm1OU2wMeta || {},
    component: () => import("/build/b2e7dd14-781e-413a-80e8-55257c207a12/pages/support/responsables/participations-to-be-treated.vue")
  },
  {
    name: "admin-missions-id-trouver-des-benevoles-redirect",
    path: "/admin/missions/:id()/trouver-des-benevoles/redirect",
    component: () => import("/build/b2e7dd14-781e-413a-80e8-55257c207a12/pages/admin/missions/[id]/trouver-des-benevoles/redirect.vue")
  },
  {
    name: "admin-statistics-departements-organisations-a-valider",
    path: "/admin/statistics/departements/organisations-a-valider",
    meta: organisations_45a_45valider00ke6Q1bBALifXNjAia_454p2ELQxLNYb5Saoazj0HbVgMeta || {},
    component: () => import("/build/b2e7dd14-781e-413a-80e8-55257c207a12/pages/admin/statistics/departements/organisations-a-valider.vue")
  },
  {
    name: "inscription-responsable-step-charte-bon-fonctionnement",
    path: "/inscription/responsable/step/charte-bon-fonctionnement",
    component: () => import("/build/b2e7dd14-781e-413a-80e8-55257c207a12/pages/inscription/responsable/step/charte-bon-fonctionnement.vue")
  },
  {
    name: "inscription-responsable-step-collectivite-confirmation",
    path: "/inscription/responsable/step/collectivite-confirmation",
    meta: collectivite_45confirmation9weWCMZjNI7VlxDSKfblNGpTyaCVDx0kAYt9MJu0UUMMeta || {},
    component: () => import("/build/b2e7dd14-781e-413a-80e8-55257c207a12/pages/inscription/responsable/step/collectivite-confirmation.vue")
  },
  {
    name: "inscription-responsable-step-organisation-confirmation",
    path: "/inscription/responsable/step/organisation-confirmation",
    meta: organisation_45confirmationUjfvqLA8vHcoKUfTFJ8_gethIQJwj6CTb7GRgQRVTUIMeta || {},
    component: () => import("/build/b2e7dd14-781e-413a-80e8-55257c207a12/pages/inscription/responsable/step/organisation-confirmation.vue")
  },
  {
    name: "admin-statistics-organisations-participations-a-valider",
    path: "/admin/statistics/organisations/participations-a-valider",
    meta: participations_45a_45validervZ_45_N9nw2N9YIcRw7aEss76SwpcAJ_45qdje9vMv9RBDEMeta || {},
    component: () => import("/build/b2e7dd14-781e-413a-80e8-55257c207a12/pages/admin/statistics/organisations/participations-a-valider.vue")
  },
  {
    name: "admin-statistics-organisations-participations-refusees-annulees",
    path: "/admin/statistics/organisations/participations-refusees-annulees",
    meta: participations_45refusees_45annulees6F4dAt7Lt3oWcdoqyeNU6jngrgMy9nM_O35GCEl69VwMeta || {},
    component: () => import("/build/b2e7dd14-781e-413a-80e8-55257c207a12/pages/admin/statistics/organisations/participations-refusees-annulees.vue")
  },
  {
    name: component_45stubwnIIvCymbsetrhMzSN4UqivqhDWgXlKt7052s85uwYYMeta?.name,
    path: "/register/volontaire/:pathMatch(.*)",
    component: component_45stubwnIIvCymbsetrhMzSN4UqivqhDWgXlKt7052s85uwYY
  },
  {
    name: component_45stubwnIIvCymbsetrhMzSN4UqivqhDWgXlKt7052s85uwYYMeta?.name,
    path: "/register/responsable/:pathMatch(.*)",
    component: component_45stubwnIIvCymbsetrhMzSN4UqivqhDWgXlKt7052s85uwYY
  },
  {
    name: component_45stubwnIIvCymbsetrhMzSN4UqivqhDWgXlKt7052s85uwYYMeta?.name,
    path: "/user/settings",
    component: component_45stubwnIIvCymbsetrhMzSN4UqivqhDWgXlKt7052s85uwYY
  },
  {
    name: component_45stubwnIIvCymbsetrhMzSN4UqivqhDWgXlKt7052s85uwYYMeta?.name,
    path: "/user/:pathMatch(.*)",
    component: component_45stubwnIIvCymbsetrhMzSN4UqivqhDWgXlKt7052s85uwYY
  },
  {
    name: component_45stubwnIIvCymbsetrhMzSN4UqivqhDWgXlKt7052s85uwYYMeta?.name,
    path: "/dashboard/structure/:pathMatch(.*)",
    component: component_45stubwnIIvCymbsetrhMzSN4UqivqhDWgXlKt7052s85uwYY
  },
  {
    name: component_45stubwnIIvCymbsetrhMzSN4UqivqhDWgXlKt7052s85uwYYMeta?.name,
    path: "/dashboard/mission/:pathMatch(.*)",
    component: component_45stubwnIIvCymbsetrhMzSN4UqivqhDWgXlKt7052s85uwYY
  },
  {
    name: component_45stubwnIIvCymbsetrhMzSN4UqivqhDWgXlKt7052s85uwYYMeta?.name,
    path: "/dashboard/participation/:pathMatch(.*)",
    component: component_45stubwnIIvCymbsetrhMzSN4UqivqhDWgXlKt7052s85uwYY
  },
  {
    name: component_45stubwnIIvCymbsetrhMzSN4UqivqhDWgXlKt7052s85uwYYMeta?.name,
    path: "/dashboard/profile/:pathMatch(.*)",
    component: component_45stubwnIIvCymbsetrhMzSN4UqivqhDWgXlKt7052s85uwYY
  },
  {
    name: component_45stubwnIIvCymbsetrhMzSN4UqivqhDWgXlKt7052s85uwYYMeta?.name,
    path: "/dashboard/reseaux/:pathMatch(.*)",
    component: component_45stubwnIIvCymbsetrhMzSN4UqivqhDWgXlKt7052s85uwYY
  },
  {
    name: component_45stubwnIIvCymbsetrhMzSN4UqivqhDWgXlKt7052s85uwYYMeta?.name,
    path: "/inscription/organisation",
    component: component_45stubwnIIvCymbsetrhMzSN4UqivqhDWgXlKt7052s85uwYY
  },
  {
    name: component_45stubwnIIvCymbsetrhMzSN4UqivqhDWgXlKt7052s85uwYYMeta?.name,
    path: "/statistiques",
    component: component_45stubwnIIvCymbsetrhMzSN4UqivqhDWgXlKt7052s85uwYY
  },
  {
    name: component_45stubwnIIvCymbsetrhMzSN4UqivqhDWgXlKt7052s85uwYYMeta?.name,
    path: "/activites/accompagnement-aux-activites-sportives",
    component: component_45stubwnIIvCymbsetrhMzSN4UqivqhDWgXlKt7052s85uwYY
  },
  {
    name: component_45stubwnIIvCymbsetrhMzSN4UqivqhDWgXlKt7052s85uwYYMeta?.name,
    path: "/sitemap.xml",
    component: component_45stubwnIIvCymbsetrhMzSN4UqivqhDWgXlKt7052s85uwYY
  }
]